import { RING_METRIC_KEY_BY_PART_TYPE } from '../../constants';
import { useEffect } from 'react';

import useDroneWear from 'hooks/useDroneWear';

import type { HealthMetric, Props, UseData } from './types';

const useData = ({ drone, refreshToken }: Props): UseData => {
    const { fetch, worstWearByPartType } = useDroneWear({ drone });

    useEffect(() => {
        fetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [drone.id, refreshToken]);

    const metrics = Object.entries(RING_METRIC_KEY_BY_PART_TYPE).reduce<HealthMetric[]>(
        (ringMetrics, [partType, text]) => {
            const value = worstWearByPartType[partType];

            return value === undefined || value === null
                ? ringMetrics
                : [...ringMetrics, { text, value }];
        },
        []
    );

    return { metrics };
};

export default useData;
